module.exports = __webpack_public_path__ + "static/php-7be7348ea07780291787cb3825fbf59f.svg";